import { createEffect } from "solid-js";
//import { useAuthState } from "@/context/auth";
import { SidebarProvider, SidebarInset } from "@/components/shadcn/sidebar";
import { AppHeader } from "./components/header";
import { AppSidebar } from "./components/sidebar";
import { DemoSidebar } from "./demo/sidebar";
import { useLocation, useNavigate } from "@solidjs/router";
import { useAuthentication } from "../context/auth";

export default function DashboardLayout(props) {

  const { isAuthenticated, currentUser } = useAuthentication();
  const navigate = useNavigate();

  createEffect(() => {
    if (!isAuthenticated()) {
      navigate("/auth/login");
    }
  });

  return (
    <Show when={isAuthenticated()}>
      <SidebarProvider class="flex h-[100vh] w-full bg-slate-100">
        <AppSidebar user={currentUser()} />
        <SidebarInset class="bg-slate-100 dark:bg-black/90">
          <AppHeader user={currentUser()} />
          <div class="flex flex-1 flex-col gap-4 p-4 pt-0 md:pt-4 lg:gap-6 lg:p-6">
            {props.children}
          </div>
        </SidebarInset>
      </SidebarProvider>
    </Show>
  );
}
